import React from "react";
import { Translation, t } from "../../../core/translate";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { selectors as routerSelectors } from "../../../../redux/router";
import { Button, TextField, Form } from "@vitalsource/vstui";
import { cherry } from "@vitalsource/vstui/colors";
import { actions as userActions } from "../../../../redux/user";
import FormAlert from "../form-alert";
import ContainerLayout from "../container-layout";
import Spinner from "../../../components/spinner";
import { emailPattern } from "../utils";
import WelcomeText from "../welcome-text";
import Link from "../../../components/link";
import createThemedComponent from "@vitalsource/vstui/themes/createThemedComponent";

const BlackLink = createThemedComponent(Link, {
  Button_color_themePrimaryNaked: "inherit",
  Button_color_themePrimaryNaked_active: "inherit",
  Button_color_themePrimaryNaked_focus: "inherit",
  Button_color_themePrimaryNaked_hover: "inherit"
});

class Activation extends React.Component {
  state = { email: "" };

  submit = e => {
    e.preventDefault();
    const { resent, email, emailSent } = this.state;
    if (!resent) {
      //
      this.setState({ isResendingEmail: true });
      this.props
        .resendActivationEmail(email, this.props.returnRoute)
        .then(() => {
          this.setState({
            emailSent: true,
            resent: emailSent,
            isResendingEmail: false,
            emailSentAt: new Date().getTime()
          });
        })
        .catch(() => {
          // No activation requests :(
          this.setState({
            noActivationRequest: true,
            isResendingEmail: false,
            emailSentAt: new Date().getTime()
          });
        });
    }
  };

  onEmailChange = e => {
    this.setState({ email: e.currentTarget.value });
  };

  reset = () => {
    this.setState({
      email: "",
      emailSent: false,
      resent: false,
      noActivationRequest: false
    });
  };

  renderNoActivations() {
    return (
      <FormAlert
        level="error"
        key={`activation-error"-${this.state.emailSentAt}`}
      >
        <div>
          <Translation id="activation.no-activation-request">
            There are no activations associated with this email.
          </Translation>
        </div>
        <div>
          <Translation
            id="activation.change-email-or-support-no-html"
            support={
              <Button
                inline
                href={Fraction.Brand.Support.url}
                color="white"
                colorBehindButton={cherry.getShade(2)}
                target="_blank"
              >
                <Translation id="global-bar.support">support</Translation>
              </Button>
            }
          >
            Please try another email or contact support.
          </Translation>
        </div>
      </FormAlert>
    );
  }

  renderEmailSent() {
    const { email, resent } = this.state;
    return (
      <div>
        <FormAlert level="warning">
          <Translation
            id="activation.email-sent-no-html"
            email={<b>{email}</b>}
          >
            We’ve sent an email to <b>{email}</b>, follow the directions in the
            email to complete your registration.
          </Translation>
        </FormAlert>
        {resent && (
          <FormAlert level="warning">
            <Translation id="activation.activation-resent">
              Your activation link has been sent. Please check your email.
            </Translation>
          </FormAlert>
        )}
      </div>
    );
  }

  renderMessaging() {
    const { emailSent, noActivationRequest } = this.state;
    if (emailSent) {
      return this.renderEmailSent();
    } else if (noActivationRequest) {
      return this.renderNoActivations();
    } else {
      const signInLink = (
        <BlackLink
          href="/user/signin"
          inline
          className="ignore-focusring-override"
        >
          <Translation id="signin.signin-button">Sign In</Translation>
        </BlackLink>
      );
      return (
        <FormAlert level="error" key="invalid-link-error">
          <Translation id="activation.invalid-link" login={signInLink}>
            Oops, the link you clicked is no longer valid.
          </Translation>
        </FormAlert>
      );
    }
  }

  resetEmailMessaging() {
    const { resent, email } = this.state;
    if (resent) {
      return (
        <div className="decision-set-email">
          <Translation id="activation.not-email-no-html" email={<b>{email}</b>}>
            Not you? Go Back
          </Translation>{" "}
          <span>
            <Button inline onClick={this.reset}>
              <Translation id="messages.go-back">Go Back</Translation>
            </Button>
          </span>
        </div>
      );
    }
    return null;
  }

  renderActivationForm() {
    const { resent, email, emailSent } = this.state;
    return (
      <Form
        onSubmit={this.submit}
        id="activation-form"
        method="post"
        noValidate
      >
        {this.renderMessaging()}
        {!resent && (
          <TextField
            required
            fullWidth
            id="email-field"
            type="email"
            name="user[email]"
            label={t("base.email", "Email Address")}
            size="large"
            onChange={this.onEmailChange}
            value={email}
            pattern={emailPattern}
          />
        )}
        {!this.state.resent && (
          <Button id="submit-btn" fullWidth size="large">
            {emailSent
              ? t("activation.resend-email", "Resend Email")
              : t("base.continue", "Continue")}
          </Button>
        )}
        {emailSent && this.resetEmailMessaging()}
      </Form>
    );
  }

  render() {
    return (
      <ContainerLayout
        graphic="forgot"
        pageTitle={t("activation.activation", "Activation")}
        title={<WelcomeText />}
      >
        {this.renderActivationForm()}
        {this.state.isResendingEmail && <Spinner />}
      </ContainerLayout>
    );
  }
}

const mapStateToProps = state => ({
  returnRoute:
    routerSelectors.getRootRoute(state) + routerSelectors.getSearch(state),
  supportURL: brandSelectors.getBrandValue(
    state,
    "Support.url",
    "http://support.vitalsource.com/"
  )
});

const mapDispatchToProps = dispatch => ({
  resendActivationEmail: (email, url) =>
    dispatch(userActions.resendActivationEmail(email, url))
});

const ConnectedActivation = connect(
  mapStateToProps,
  mapDispatchToProps
)(Activation);

export default ConnectedActivation;
